import { Component, HostBinding, OnInit } from '@angular/core';
import { FragmentService } from 'app/services/fragment.service';
import { LoaderService } from 'app/services/loader.service';
import { MetaService } from 'app/services/meta.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  standalone: false
})
export class CategoryComponent extends BaseComponent implements OnInit {

    constructor(
      public fragmentService: FragmentService,
      public loaderService: LoaderService,
      public metaService: MetaService
    ) {
      super(fragmentService, loaderService, metaService);
    }
}
